export default __webpack_public_path__ + "static/media/2.af4cb3a1.jpeg";